<template>
  <div class="updatSeting">
    <el-row>
      <div class="model-header setting">
        <h2>Config Ngành học hot</h2>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <h4>Danh sách ngành học hot</h4>
            <div class="line">
              <el-input
                v-model="modelData.top_branch_title"
                placeholder="Ngành hot năm 2021"
                class="input-seach">
              </el-input>
            </div>
            <h4>Danh sách ngành hot</h4>
            <div v-for="(image_p) in modelData.top_branch_list" :key="image_p.key">
              <div class="line">
                <el-input v-model="image_p.text" class="input-seach" placeholder="Tên"></el-input>
                <el-input v-model="image_p.link" class="input-seach" placeholder="Link"></el-input>
                <el-button @click.prevent="removeImage2(image_p)" size="small">Xóa</el-button>
              </div>
            </div>
            <el-button class="huhu" type="default" size="mini" @click="addImage2()">Thêm link</el-button>
          </el-col>
          <el-col :span="12">
            <div class="line">
              <el-upload
                class="course-uploader"
                :action="upload.url_fit_fix"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="image_path" :src="image_path" class="courseSettig">
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh banner chính có kích thước 780 * 450
                </div>
              </el-upload>
              <div>
                <p style="padding-left: 30px;">{{ image }}</p>
                <p style="padding-left: 30px;" v-if="image">sm_{{ image }}</p>
              </div>
            </div>
            <h4>Banner chính</h4>
            <div v-for="(image_p) in modelData.top_branch_banner_list" :key="image_p.key">
              <div class="line">
                <input type="text" placeholder="Ảnh" v-model="image_p.image">
                <img :src="getImage(image_p.image)" alt="" class="image-preview">
                <el-button @click.prevent="removeImage1(image_p)" size="small">Xóa</el-button>
              </div>
            </div>
            <el-button class="huhu" type="default" size="mini" @click="addImage1()">Thêm ảnh</el-button>

            <div class="line">
            </div>
            <div class="line">
              <el-upload
                class="course-uploader"
                :action="upload.url_fit_fix2"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="image_path" :src="image_path" class="courseSettig">
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh Banner đào tạo có kích thước 1140 * 400
                </div>
              </el-upload>
              <div>
                <p style="padding-left: 30px;">{{ image }}</p>
                <p style="padding-left: 30px;" v-if="image">sm_{{ image }}</p>
              </div>
            </div>
            <h4>Banner đào tạo</h4>
            <div class="line">
              <input type="text" placeholder="Ảnh" v-model="modelData.top_branch_educate_image">
              <img :src="getImage(modelData.top_branch_educate_image)" alt="" class="image-preview">
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <div style="padding-top: 20px">
      <el-button
        :disable="!canSubmit"
        :loading="!canSubmit"
        type="warning"
        size="small"
        @click="updateModelHomeMenu()">Cập nhật</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'ConfigHeaderFooter',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'Config Header Footer'
    }
  },
  data () {
    return {
      canSubmit: true,
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      modelData: {

      },
      modelData_ID: 0,
      image: '',
      image_path: '',
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'configs/upload',
        url_not_resize: process.env.API_URI + 'configs/upload-not-resize',
        url_fit_fix: process.env.API_URI + 'configs/upload-fit-fix/780/450/780/450',
        url_fit_fix2: process.env.API_URI + 'configs/upload-not-resize-2/500/300/200',
        headers: {
          Authorization: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModelHomeMenu()
    this.configUpload()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('configs/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path)
      } else {
        return false
      }
    },
    getImage (data) {
      return process.env.IMAGE_S3_URL + 'storage/images/configs/' + data
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configs-home', text: 'Config Home' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModelHomeMenu () {
      this.canSubmit = false
      axios.get('configs/home-top-branch-school').then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.modelData = response.data.value
            this.modelData_ID = response.data.id
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModelHomeMenu (formName) {
      this.canSubmit = false
      let data = {
        'value': this.modelData
      }
      axios.put('configs/' + this.modelData_ID, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    addImage1 () {
      this.modelData.top_branch_banner_list.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'text': '',
        'image': '',
        'note': '',
        'link': '',
        'priority': 0
      })
    },
    removeImage1 (item) {
      var index = this.modelData.top_branch_banner_list.indexOf(item)
      if (index !== -1) {
        this.modelData.top_branch_banner_list.splice(index, 1)
      }
    },

    addImage2 () {
      this.modelData.top_branch_list.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'text': '',
        'link': '',
        'priority': 0
      })
    },
    removeImage2 (item) {
      var index = this.modelData.top_branch_list.indexOf(item)
      if (index !== -1) {
        this.modelData.top_branch_list.splice(index, 1)
      }
    },

    addImage3 () {
      this.modelData.footer_list_policy.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'text': '',
        'link': '',
        'priority': 0
      })
    },
    removeImage3 (item) {
      var index = this.modelData.footer_list_policy.indexOf(item)
      if (index !== -1) {
        this.modelData.footer_list_policy.splice(index, 1)
      }
    },

    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.image = response.data.name
        this.image_path = response.data.path_sm
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.huhu {
  margin-top: 10px;
}
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}
.line input {
  margin-right: 10px;
}
.image-preview {
  height: 50px;
  width: 50px;
  margin-right: 10px;
}
</style>
<style type="text/css">
.updatSeting .course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.updatSeting .course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}

.updatSeting .courseSettig {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/config-home/UpdateBranchHot.vue